import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"keyboard, midi, keys, piano"} maskId="square-filled-radius-0-stroke-1-IconKeyboard1"><path fillRule="evenodd" clipRule="evenodd" d="M3 3V22H21V3H3ZM6 4H4V21H8V13H6V4ZM9 21H15V13H13V4H11V13H9V21ZM18 4V13H16V21H20V4H18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconKeyboard1;
